"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeywordsAPI = void 0;
const base_1 = require("../base");
class KeywordsAPI extends base_1.BaseAPI {
    /**
     * Get the keyword details.
     *
     * @see https://developers.themoviedb.org/3/keywords/get-keyword-details
     */
    async details(keywordId) {
        const path = this.getPath(`/keyword/${keywordId}`);
        return this.get(path);
    }
    /**
     * Get the movies that belong to a keyword.
     *
     * We highly recommend using movie discover instead of this method as it is
     * much more flexible.
     *
     * @see https://developers.themoviedb.org/3/keywords/get-movies-by-keyword
     */
    async movies(keywordId, filters) {
        const path = this.getPath(`/keyword/${keywordId}/movies`, filters);
        return this.get(path);
    }
}
exports.KeywordsAPI = KeywordsAPI;
